<template>
  <div v-if="reportLoaded">
    <fleet-health-history-report-card
      v-for="(reportData, index) of report.results"
      :key="index"
      :customer-report="reportData"
      :start-date="startDate"
      :end-date="endDate" />
  </div>
</template>

<script>
import FleetHealthHistoryReportCard from '@/components/report/performance-dashboard/FleetHealthHistoryReportCard'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ReportMixin from '@/components/report/ReportMixin'
import { get } from 'lodash'

export default {
  name: 'FleetHealthHistoryReport',
  components: {
    FleetHealthHistoryReportCard
  },
  mixins: [
    CurrentUserMixin,
    ReportMixin
  ],
  computed: {
    /**
     * The start date of the report.
     */
    startDate () {
      return get(this, 'report.parameters.startDate')
    },
    /**
     * The end date of the report.
     */
    endDate () {
      return get(this, 'report.parameters.endDate')
    }
  }
}
</script>
